import sanitizeForReact from 'Utils/sanitize-for-react';
import runStrategies from 'Utils/run-strategies';
import strategies from './social-graph-title/index';

export default (options = {}, getState, extraThunkArgs) =>
  sanitizeForReact(
    runStrategies(strategies)(options, getState, extraThunkArgs),
  );
